import { render, staticRenderFns } from "./wsTextEditor.vue?vue&type=template&id=1b8f7925&scoped=true&"
import script from "./wsTextEditor.vue?vue&type=script&lang=js&"
export * from "./wsTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./wsTextEditor.vue?vue&type=style&index=0&id=1b8f7925&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f7925",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VExpandXTransition,VFadeTransition,VHover,VIcon,VSheet})
